import React, { useEffect } from 'react';
import { useActivation } from '@context/MobileOne';
import { useA11y } from '@context/Utils/A11y';
import { TariffActivation } from './TariffActivation';
import { TariffSuccess } from './TariffSuccess';
import { Meta } from '@core/Meta';
import { keyValueValidation } from '@utils/globalConstant';
import { useTitle } from '@context/Utils/Title';
export function ActivationStep2() {
  // Context
  const { step2SubStep, setShowActivationHeader, setShowActivationFooter } = useActivation();
  const { tA11yTranslate, getGlobalMetaTitles } = useA11y();
  const { announceTitle } = useTitle();
  // META: handle page titles
  const { globalPageTitle, globalSuccessPageTitle } = getGlobalMetaTitles();
  const activationTariffPageTitle = tA11yTranslate('ek_global_meta_title_tariff').content;
  const isTranslationReady = keyValueValidation(
    activationTariffPageTitle,
    'ek_global_meta_title_tariff'
  );

  // Determine the page title based on the current substep
  const getPageTitle = () => {
    if (step2SubStep === 1) {
      return `${globalPageTitle} - ${globalSuccessPageTitle}`;
    } else {
      return `${globalPageTitle} - ${activationTariffPageTitle}`;
    }
  };

  useEffect(() => {
    const pageTitle = `${getPageTitle()}`;
    announceTitle(pageTitle);
  }, [step2SubStep, announceTitle]); // Re-run when substep changes

  // Hooks
  useEffect(() => {
    // Hide footer for below screens
    // 0.1.3.2 - registration step 2 - tariff success
    if (step2SubStep === 1) {
      setShowActivationHeader(false);
      setShowActivationFooter(false);
    } else {
      setShowActivationFooter(true);
      setShowActivationHeader(true);
    }
  }, [step2SubStep]);

  const renderStep2SubSteps = (subStep) => {
    switch (subStep) {
      case 0:
        return <TariffActivation />;
      case 1:
        return <TariffSuccess />;
      default:
        return <TariffActivation />;
    }
  };

  return (
    <>
      <Meta title={getPageTitle()} key={`meta-key-${step2SubStep}`} />
      {renderStep2SubSteps(step2SubStep)}
    </>
  );
}

export default ActivationStep2;
